import { styled } from '@mui/material/styles';
import { COLORS } from '../../../../utils/colors';
import { Box, Button, Modal, Typography } from '@mui/material';

export const useAccountSettingsStyles = () => {
  return {
    formControl: {
      marginBottom: '2rem',
    },
    saveButton: {
      position: 'absolute',
      right: '2rem',
      top: '1.5rem',
      display: 'flex',
      paddingLeft: '2rem',
      paddingRight: '2rem',
      backgroundColor: COLORS.PRIMARY,
      borderRadius: '2rem',
      color: '#fff !important',
      height: '2rem',
      '&: hover': {
        backgroundColor: COLORS.MEDIUM_GRAY,
      },
    },
    divider: {
      display: 'block',
      width: '100%',
      height: '1px',
      margin: '1.5rem',
      marginLeft: '0rem',
      backgroundColor: `${COLORS.MEDIUM_GRAY}`,
    },
  };
};

export const StyledOverlay = styled(Modal)({
  '& .MuiModal-backdrop': {
    //background: 'transparent',
  },
});

export const StyledModal = styled(Box)({
  position: 'absolute',
  top: '3.625rem',
  right: 0,
  minHeight: '60%',
  maxHeight: 'calc(100% - 5rem)',
  width: '55%',
  backgroundColor: COLORS.WHITE,
  boxShadow: '0 2px 10px 0 rgba(0, 0, 0, 0.26)',
  padding: '1.125rem 1.4375rem',
});

export const StyledButton = styled(Button)({
  color: '#fff !important',
  backgroundColor: COLORS.MEDIUM_GRAY,
  borderRadius: '27px',
  fontSize: '15px',
  fontWeight: 600,
  textTransform: 'none',
  cursor: 'pointer',
  border: '0px',
  '&: hover': {
    backgroundColor: COLORS.MEDIUM_GRAY,
    border: '0px',
  },
});

export const FlexBetween = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});
